import { render } from "./VoucherSummaryTab.vue?vue&type=template&id=6e0eca6a&scoped=true"
import script from "./VoucherSummaryTab.vue?vue&type=script&lang=js"
export * from "./VoucherSummaryTab.vue?vue&type=script&lang=js"

import "./VoucherSummaryTab.vue?vue&type=style&index=0&id=6e0eca6a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e0eca6a"]])

export default __exports__